import { handleAction } from 'redux-actions';
import { setInitialLoad } from '../actions/global';

export const initialLoadReducer = handleAction(
  setInitialLoad,
  (_, { payload }) => payload,
  true
);
